import { useEffect, useRef, useState } from 'react';
import { useTransactionsUploadMutation } from '../transactions/store/services';
import UploadDocument from '../../components/upload-document/upload-document';
import { UploadResponse } from '../transactions/type';
import { useCheckDocumentStringNameMutation } from '../../../../../store/service';

const DocumentUploadHOC = ({
  setPanelIsOpen,
  setFileName,
  setOrderUploadId,
}: {
  setPanelIsOpen: (data: boolean) => void;
  setFileName: (data: string) => void;
  setOrderUploadId: (data: string) => void;
}) => {
  const uploadInputRef = useRef<HTMLInputElement | null>(null);

  const [uploadError, setUploadError] = useState('');
  const [uploadDocumentError, setUploadDocumentError] = useState<
    { name: string; error: string } | undefined
  >(undefined);

  const [checkDocumentName, { isLoading: checkDocumentNameInProgress }] =
    useCheckDocumentStringNameMutation();
  const [upload, { isLoading, isSuccess }] = useTransactionsUploadMutation();

  const onUpload = async (data: FileList) => {
    setUploadError('');
    setUploadDocumentError(undefined);

    const file = data[0];

    setFileName(file.name);

    const checkNameResponse = (await checkDocumentName({
      value: file.name,
    })) as {
      error?: {
        data: {
          message?: {
            constraints: Record<string, string>;
          }[];
        };
      };
    };

    if (!checkNameResponse?.error) {
      const response = (await upload(file)) as unknown as {
        data: UploadResponse[];
        error?: any;
        message?: string;
      };

      if (response && response.error) {
        if (
          response?.error?.originalStatus &&
          response?.error?.originalStatus === 413
        ) {
          setUploadError('File size too large');
        } else {
          setUploadError(
            response?.error?.data?.message || 'Something was wrong. Try again',
          );
        }
      } else {
        setOrderUploadId(response.data[0].id);
      }
    } else if (
      checkNameResponse?.error &&
      checkNameResponse?.error?.data?.message
    ) {
      const errorItem = checkNameResponse?.error?.data?.message[0]?.constraints;

      if (errorItem) {
        setUploadDocumentError({
          name: file.name,
          error: Object.values(errorItem)[0],
        });
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      setPanelIsOpen(true);

      if (uploadInputRef && uploadInputRef?.current) {
        uploadInputRef.current.value = '';
      }
    }
  }, [isSuccess, uploadInputRef]);

  return (
    <UploadDocument
      onUpload={onUpload}
      fileUploadInProgress={checkDocumentNameInProgress || isLoading}
      uploadInputRef={uploadInputRef}
      uploadError={uploadError}
      uploadDocumentError={uploadDocumentError}
    />
  );
};

export default DocumentUploadHOC;
